@if (form && controlName) {
  <mat-form-field [formGroup]="form">
    @if (formato) {
      <h3><strong>Formato: </strong> {{ formato }}</h3>
    }
    <p>
      <textarea
        #lineCounter
        id="lineCounter"
        wrap="off"
        readonly
        [ngModel]="lineCounterValue"
        [ngModelOptions]="{ standalone: true }"
      >
      </textarea>
      <textarea
        #textArea
        id="textArea"
        wrap="off"
        matInput
        [formControlName]="controlName"
        required
        (scroll)="onScroll()"
        (input)="onInput()"
      ></textarea>
    </p>
    <mat-hint>
      {{ ejemplo() }}
    </mat-hint>
    @if (form.get(controlName)?.hasError("error")) {
      <mat-error>
        {{ getErrorMessage() }}
      </mat-error>
    }
  </mat-form-field>
}
